import Cookies from 'js-cookie'
const checkCookie = () => {
  $('.search-input ').on('focus', function() {
    removeCookieOrWebStorage('backToBrowsing');
  });
  $('#main-nav > * ').on('click', function() {
    removeCookieOrWebStorage('backToBrowsing');
  });
  var cookieEnabled = (navigator.cookieEnabled) ? true : false;
  if (typeof navigator.cookieEnabled == 'undefined' && !cookieEnabled) {
    document.cookie = 'testcookie';
    cookieEnabled = (document.cookie.indexOf('testcookie') != -1) ? true : false;
  }
  if($('#no-cookies-alert').length < 1){
    var prependTo = $('body');
    if($('.mobilePage').length > 0){
      prependTo = $('#headerWrap');
    }
    (cookieEnabled) ? true : prependTo.prepend(`<div class="tipytop noscriptmsg"><div data-twist="no-cookies" id="no-cookies-alert" class="alert alert-danger" role="alert"><p>Your browser currently has Cookies disabled. Please turn Cookies on to have the best shopping experience on Dillards.com. Click here to <a href="http://www.dillards.com/html/cookie_disable_instructions.html">enable</a>.</p></div></div>`);
  }
};

const getCookie = (e) => {
  var t = document.cookie.match(e + "=(.*?)(;|$)");
  return t ? unescape(t[1]) : null;
};

const getCookieOrWebStorage = (name) => {
  if (typeof(sessionStorage) == 'undefined') return Cookies.get(name);
  else {
    var storageLevel = localStorage;
    var domVal = localStorage.getItem(name);
    if (!domVal) {
      storageLevel = sessionStorage;
      domVal = sessionStorage.getItem(name);
    }
    if (domVal) {
      try {
        var storedObj = JSON.parse(domVal);
        if (storedObj.expDate) {
          if (storedObj.expDate < Date.now()) {
            return storageLevel.removeItem(name);
          }
          domVal = storedObj.value;
        }
      } catch (e) {}
    }
    return domVal;
  }
};

const removeCookieOrWebStorage = (name) => {
  if (typeof(sessionStorage) == 'undefined' && getCookieOrWebStorage(name)) Cookies.remove(name);
  else {
    if (localStorage.getItem(name)) localStorage.removeItem(name);
    else if (sessionStorage.getItem(name)) sessionStorage.removeItem(name);
  }
};

const getNumberFromCookie = (e, t) => {
  let userCookie = getUserCookieValue(e, t),
    n = (userCookie == null) ? '0' : userCookie;
  return n;
};

const getUserCookieValue = (e, t) => {
  var n = getCookie(e);
  if (n == null) return null;
  var s = `${t}~~~(.*?)(@)`,
    o = n.match(s);
  return o ? unescape(o[1]) : null;
};

const setCookieOrWebStorage = (storageType, name, value) => {
  if (typeof(sessionStorage) == 'undefined') {
    Cookies.set(name, value, {
      path: '/',
      domain: false
    });
  } else {
    if (storageType == "localStorage") localStorage.setItem(name, value);
    else if (storageType == "sessionStorage") sessionStorage.setItem(name, value);
    setExpiringCookies(name, "", -1);
  }
};

const setExpiringCookieOrWebStorage = (storageType, name, value, expirationDate) => {
  if (typeof(sessionStorage) == 'undefined') {
    Cookies.set(name, value, {
      path: '/',
      domain: false,
      expires: expirationDate
    });
  } else {
    var jsonToStore = {
      "value": value,
      "expDate": expirationDate.getTime()
    };
    jsonToStore = JSON.stringify(jsonToStore);
    if (storageType == "localStorage") localStorage.setItem(name, jsonToStore);
    else if (storageType == "sessionStorage") sessionStorage.setItem(name, jsonToStore);
    setExpiringCookies(name, "", -1);
  }
};

const setCookies = (cookieName, codeValue) => {
  Cookies.set(cookieName, codeValue, {
    path: '/',
    domain: document.domain
  });
};
window.setCookie = setCookies

const setExpiringCookies = (cookieName, codeValue, expriringDays) => {
  Cookies.set(cookieName, codeValue, {
    path: '/',
    domain: document.domain,
    expires: expriringDays
  });
};

const inWebStorage = (cookieName) => {
  if ((typeof(sessionStorage) != 'undefined') && (sessionStorage.getItem(cookieName) !== null)) return true;
  else if ((typeof(localStorage) != 'undefined') && (localStorage.getItem(cookieName) !== null)) return true;
  return false;
}

const expireObsoleteCookies = () => {
  var obsoleteCookies = [
    "loggedOn", "RSVS_USR", "USERLOGGEDIN", "userName", "defaultRegistry",
    "priceMode", "addToWishListItemsAdded", "addToWishListResponse"
  ];
  $.each(obsoleteCookies, function(i, cookieName) {
    setExpiringCookies(cookieName, "", -1);
  });
  var checkCookies = ["siteFormat", "unitsSold", "blanketCookie", "intlCacheCallVariable"];
  $.each(checkCookies, function(i, cookieName) {
    if (inWebStorage(cookieName)) setExpiringCookies(cookieName, "", -1);
  });
}

const setAkamaiWait = (akamaiValToSet) => {
	var cookieValInt = parseInt(Cookies.get('cma'), 10);
	var akamaiValInt = parseInt(akamaiValToSet, 10);
	
	if (!cookieValInt || !akamaiValInt) return;
	
	if (cookieValInt > akamaiValInt) {
    	var domain = '.' + document.domain;
    	if (document.domain == "localhost") {
    		// use false for localhost
    		Cookies.set("cma", akamaiValToSet, {
    			path: '/',
    			domain: false
    		});
    	} else {
    		Cookies.set("cma", akamaiValToSet, {
    			path: '/',
    			domain: domain
    		});
    	}
    }
}

export {
  checkCookie,
  expireObsoleteCookies,
  getCookie,
  getCookieOrWebStorage,
  getNumberFromCookie,
  getUserCookieValue,
  setCookieOrWebStorage,
  setCookies,
  setExpiringCookies,
  setExpiringCookieOrWebStorage,
  removeCookieOrWebStorage,
  setAkamaiWait
}
